/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateGitContent {
    getFixupPrototypeFunction() { return TemplateGitContent.fixupPrototype; }

    static newInstance(model: Partial<TemplateGitContent>): TemplateGitContent {
        let obj = Object.assign(new TemplateGitContent(), model);
        TemplateGitContent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateGitContent>): TemplateGitContent {
        if (!model) return null;
        return TemplateGitContent.newInstance(<TemplateGitContent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateGitContent) {
        if (!obj) return;

        models.TemplateGitContent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateGitContent): boolean {
        Object.setPrototypeOf(obj, TemplateGitContent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Git/URL location of the template content
     */
    content_url: string;

    /**
     * Username if the source is authenticated
     */
    content_username: string;

    /**
     * Password or private key if the source is authenticated
     */
    content_password_or_key: string;

    /**
     * Git branch name. Git-only; empty for a plain URL fetch
     */
    content_branch: string;

    /**
     * Sub-path within the git repo. Git-only
     */
    absolute_path: string;

    /**
     * 'public' or 'private' (uses the credential fields above)
     */
    repo_type: models.TemplateRepoType;

}
